import { render, staticRenderFns } from "./ClientRegister.vue?vue&type=template&id=09e2e5b3&scoped=true&"
import script from "./ClientRegister.vue?vue&type=script&lang=js&"
export * from "./ClientRegister.vue?vue&type=script&lang=js&"
import style0 from "./ClientRegister.vue?vue&type=style&index=0&id=09e2e5b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e2e5b3",
  null
  
)

export default component.exports